<template>
  <div class="nav">
    <div id="nav">
      <div class="top-nav">
        <div class="top-nav__inner">
          <div class="dropdown">
            <button class="dropdown__btn">
              <router-link to="/" class="top-nav__link">HOME</router-link>
            </button>
          </div>
          <div class="dropdown">
            <button class="dropdown__btn">ARTISTS</button>
            <div class="dropdown__content">
              <router-link
                v-for="(name, i) in names"
                :key="`artists${i}`"
                :to="{ name: 'artist', params: { artistName: name } }"
                >{{ name }}</router-link
              >
            </div>
          </div>
          <div class="dropdown">
            <button class="dropdown__btn">MUSIC</button>
            <div class="dropdown__content">
              <router-link
                v-for="(name, i) in names"
                :key="`music${i}`"
                :to="{ name: 'music', params: { artistName: name } }"
                >{{ name }}</router-link
              >
            </div>
          </div>
          <div class="dropdown">
            <button class="dropdown__btn">VIDEOS</button>
            <div class="dropdown__content">
              <router-link
                v-for="(name, i) in names"
                :key="`videos${i}`"
                :to="{ name: 'videos', params: { artistName: name } }"
                >{{ name }}</router-link
              >
            </div>
          </div>

          <div class="dropdown">
            <button class="dropdown__btn">
              <router-link to="/live" class="top-nav__link"
                >LIVE REPORTS</router-link
              >
            </button>
          </div>


          <div class="dropdown">
            <button class="dropdown__btn">
              <a :href="storeUrl">STORE</a>
            </button>
          </div>

          <!-- <div class="dropdown">
            <button class="dropdown__btn">
              <router-link to="/party" class="top-nav__link">PARTY</router-link>
            </button>
          </div>-->
          <div class="dropdown">
            <button class="dropdown__btn">
              <router-link to="/news" class="top-nav__link">NEWS</router-link>
            </button>
          </div>
          <!-- <div class="dropdown">
            <button class="dropdown__btn">
              <router-link to="/photo" class="top-nav__link">PHOTO</router-link>
            </button>
          </div>-->
          <div class="dropdown">
            <button class="dropdown__btn">
              <router-link to="/contact" class="top-nav__link"
                >CONTACT</router-link
              >
            </button>
          </div>
        </div>
      </div>
    </div>

    <Slide class="burger" right :closeOnNavigation="true">
      <router-link to="/" class="top-nav__link">
        <span>Home</span>
      </router-link>

      <div class="dropdown">
        <button class="dropbtn">
          <span>Artists&nbsp;</span>
          <i class="fa fa-caret-right"></i>
        </button>
        <div class="dropdown-content">
          <router-link
            v-for="(name, i) in names"
            :key="`m-artists${i}`"
            :to="{ name: 'artist', params: { artistName: name } }"
          >
            <span>{{ name }}</span>
          </router-link>
        </div>
      </div>

      <div class="dropdown">
        <button class="dropbtn">
          <strong>Music&nbsp;</strong>
          <i class="fa fa-caret-right"></i>
        </button>
        <div class="dropdown-content">
          <router-link
            v-for="(name, i) in names"
            :key="`m-music${i}`"
            :to="{ name: 'music', params: { artistName: name } }"
          >
            <span>{{ name }}</span>
          </router-link>
        </div>
      </div>

      <div class="dropdown">
        <button class="dropbtn">
          <strong>Videos&nbsp;</strong>
          <i class="fa fa-caret-right"></i>
        </button>
        <div class="dropdown-content">
          <router-link
            v-for="(name, i) in names"
            :key="`videos${i}`"
            :to="{ name: 'videos', params: { artistName: name } }"
          >
            <span>{{ name }}</span>
          </router-link>
        </div>
      </div>

      <router-link to="/live" class="top-nav__link">
        <span>Live Reports</span>
      </router-link>

      <a :href="storeUrl">
        <span>Store</span>
      </a>

      <!-- <router-link to="/contact" class="top-nav__link">
        <span>Party</span>
      </router-link>-->
      <router-link to="/news" class="top-nav__link">
        <span>News</span>
      </router-link>
      <!-- <router-link to="/contact" class="top-nav__link">
        <span>Photo</span>
      </router-link>-->
      <router-link to="/contact" class="top-nav__link">
        <span>Contact</span>
      </router-link>
    </Slide>
  </div>
</template>

<script>
import { getArtistsNames } from "../functions/artists-function";
import { Slide } from "vue-burger-menu";

export default {
  data() {
    return {
      drawer: false,
      names: [],
      storeUrl: "https://islandstatemusicinc.stores.jp/",
    };
  },
  watch: {
    function() {
      this.getArtistsNames();
    },
  },
  methods: {
    getArtistsNames: async function () {
      this.names = await getArtistsNames();
    },
  },
  mounted: function () {
    this.getArtistsNames();
    this.isOpen = false;
  },
  components: {
    Slide,
  },
};
</script>

<style lang="scss" scoped>
.nav {
  border-top: 1px gray solid;
  border-bottom: 1px gray solid;
}
.top-nav {
  background-color: #0c0c0c;
  overflow: hidden;
  display: flex;
  justify-content: space-evenly;
  &__link {
    color: silver;
    // color: #f2f2f2;
    text-decoration: none;
    &:hover {
      font-weight: 600;
    }
    &.active {
      color: #38e0f2;
    }
  }
  &__inner {
    max-width: 860px;
    margin-left: auto;
    margin-right: auto;
  }
}

/* The dropdown container */
.dropdown {
  $base: &;
  float: left;

  /* Show the dropdown menu on hover */
  &:hover {
    #{$base}__content {
      display: block;
    }
  }

  /* Dropdown button */
  &__btn {
    font-size: 12px;
    border: none;
    outline: none;
    color: silver;
    padding: 15px 16px;
    background-color: inherit;
    font-family: inherit; /* Important for vertical align on mobile phones */
    margin: 0; /* Important for vertical align on mobile phones */

    /* Add a red background color to navbar links on hover */
    &:hover {
      font-weight: bold;
    }
  }

  /* Dropdown content (hidden by default) */
  &__content {
    display: none;
    position: absolute;
    font-size: 12px;
    background-color: rgba(0, 0, 0, 0.9);
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 999;

    /* Links inside the dropdown */
    a {
      float: none;
      color: #fff;
      padding: 12px 16px;
      text-decoration: none;
      display: block;
      text-align: left;

      /* Add a grey background color to dropdown links on hover */
      &:hover {
        color: #bf0f1e;
      }
    }
  }
}

a,
a:visited,
a:hover,
a:active {
  text-decoration: none;
  color: inherit;
}

.burger {
  display: none;
}

button#nav-btn {
  display: none;
}

@media screen and (max-width: 480px) {
  .nav {
    border-top: none;
    border-bottom: none;
  }

  .dropdown {
    float: left;
    overflow: hidden;
  }

  /* Style the dropdown button to fit inside the topnav */
  .dropdown .dropbtn {
    border: none;
    color: white;
    padding-left: 9px;
    background-color: inherit;
    font-family: inherit;
  }

  /* Style the dropdown content (hidden by default) */
  .dropdown-content {
    display: none;
    position: absolute;
    background-color: inherit;
    min-width: 160px;
    z-index: 1;
  }

  /* Style the links inside the dropdown */
  .dropdown-content a {
    float: none;
    color: white;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
  }

  /* Add a dark background on topnav links and the dropdown button on hover */
  .topnav a:hover,
  .dropdown:hover .dropbtn {
    background-color: #555;
    color: white;
  }

  /* Add a grey background to dropdown links on hover */
  .dropdown-content a:hover {
    background-color: #ddd;
    color: black;
  }

  /* Show the dropdown menu when the user moves the mouse over the dropdown button */
  .dropdown:hover .dropdown-content {
    display: block;
  }

  .dropdown {
    float: none;
  }
  .dropdown-content {
    position: relative;
  }
  .dropdown .dropbtn {
    display: block;
    width: 100%;
    text-align: left;
  }

  .burger {
    display: unset;
  }

  button#nav-btn {
    display: block;
    position: fixed;
    z-index: 11;
    top: 25px;
    right: 25px;
    background: transparent;
    border: none;
  }
  //ハンバーガーボタン
  .hamburger {
    position: relative;
    display: block;
    width: 40px;
    height: 40px;
    .bdr {
      position: absolute;
      left: 0;
      width: 100%;
      height: 2px;
      border-radius: 4px;
      background: #fff;
      transition: all 0.5s;
      &:nth-child(1) {
        top: 0;
      }
      &:nth-child(2) {
        top: 15px;
      }
      &:nth-child(3) {
        top: 30px;
      }
    }
    &.is-active {
      .bdr {
        background: #000;
        &:nth-child(1) {
          transform: translateY(20px) rotate(-45deg);
        }
        &:nth-child(2) {
          opacity: 0;
        }
        &:nth-child(3) {
          transform: translateY(-20px) rotate(45deg);
        }
      }
    }
  }

  .cross-style {
    right: 15px;
    top: 20px;
  }

  .top-nav {
    display: none;
    margin: 20px 0;
  }
  .isActive01 {
    display: block !important;
  }

  .dropdown {
    float: initial;
  }
}
</style>
